import Api from '../api/Api';
import resolve from '../util/Configuracao';

class GuiaApi extends Api {
  async consultarGuiasDoLote(codLoteGuia) {
    try {
      const urlConsultarGuiasDoLote = resolve('urlConsultarGuiasDoLote') + codLoteGuia + '/guia';
      const response = await this.fetch(urlConsultarGuiasDoLote);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarGuia(codLote, codGuia) {
    try {
      const urlConsultarGuia = resolve('urlConsultarGuia') + codLote + '/guia/' + codGuia;
      const response = await this.fetch(urlConsultarGuia);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDetalhesGuia(codGuia, codLoteGuia, codTipoGuia) {
    try {
      const urlConsultarDetalhesGuia = resolve('urlConsultarDetalhesGuia') + codLoteGuia + '/guia/' + codGuia + '/tipo/' + codTipoGuia;
      const response = await this.fetch(urlConsultarDetalhesGuia);
      // console.log(response.data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiaOriginal(codGuia, codLoteGuia) {
    try {
      const urlConsultarGuiaOriginal = resolve('urlConsultarGuiaOriginal') + codLoteGuia + '/guia/' + codGuia + '/original';
      const response = await this.fetch(urlConsultarGuiaOriginal);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiasSolicitacao(codLoteGuia, txtSenha, txtMatricula) {
    
    try {
      const urlConsultarGuiasSolicitacao = resolve('urlConsultarGuiasSolicitacao') + codLoteGuia + '/guia/guias_solicitacao/' + txtSenha + '/' + txtMatricula;
      const response = await this.fetch(urlConsultarGuiasSolicitacao);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiasDuplicadas(codGuia, codLoteGuia, elemento) {
    try {
      const urlConsultarGuiasDuplicadas = resolve('urlConsultarGuiasDuplicadas') + codLoteGuia + '/guia/' + codGuia + '/guias_duplicidade/' + elemento.id + '/tipo/' + elemento.tipoElementoGuia + '/item/' + elemento.codItemTabela;
      const result = await this.fetch(urlConsultarGuiasDuplicadas);
      return result.data;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerAuditoria(codLote, codGuia) {
    const url = resolve('urlDesfazerAuditoriaGuia');
    const result = await this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async glosar(codLote, codGuia) {
    const url = resolve('urlGlosarGuia');
    const result = await this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async auditarAutomaticamente(codLote, codGuia) {
    const url = resolve('urlAuditarAutomaticamenteGuia');
    const result = await this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async autorizar(codLote, codGuia) {
    const url = resolve('urlAutorizarGuia');
    const result = await this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }
  async salvarParecerAuditoria(codLote, codGuia, txtParecer) {
    const urlSalvarParecerAuditoria = resolve('urlSalvarParecerAuditoria') + codLote + '/guia/' + codGuia + '/txt_parecer_auditoria';
    const result = await this.fetch(urlSalvarParecerAuditoria, 'PUT', txtParecer, { 'content-type': 'application/json' });
    return result;
  }
  async salvarMotivoGlosaGuia(guia) {
    const urlSalvarMotivoGlosaGuia = resolve('urlSalvarMotivoGlosaGuia');
    const result = await this.fetch(urlSalvarMotivoGlosaGuia, 'POST', guia, { 'content-type': 'application/json' });
    return result;
  }
  async salvarGuiaConferida(codLote, codGuia, indConferida) {
    const urlSalvarGuiaConferida = resolve('urlSalvarGuiaConferida') + codLote + '/guia/' + codGuia + '/salvar_guia_conferida/' + indConferida;
    const result = await this.fetch(urlSalvarGuiaConferida, 'PUT');
    return result;
  }

  async consultarGuiasLoteRecurso (numDemonstrativo, numProtocolo, codTipoGuia, seqPrestador, codGuiasSelecionadas) {
    let guias = [];
    let brancoAcoes = '';
    let protocolo = numProtocolo === '' ? 'vazio' : numProtocolo;
    const urlGuiasLoteRecurso = resolve('urlGuiasLoteRecurso') + numDemonstrativo + '/' + protocolo + '/' + codTipoGuia + '/' + seqPrestador; 
    const { data } = await this.fetch(urlGuiasLoteRecurso, 'post', codGuiasSelecionadas);
    data.map(res => {
      const { codGuia, numGuiaPrestador, numGuiaOperadora, numCarteiraTst, nomeBeneficiario, valTotalGlosado, valTotalLiberado, valTotalProcessado, codVersaoTiss, txtNumeroFatura } = res;
      guias.push(Object.values({ codGuia, numGuiaPrestador, numGuiaOperadora, numCarteiraTst, nomeBeneficiario, valTotalProcessado, valTotalLiberado, valTotalGlosado, codVersaoTiss, txtNumeroFatura, brancoAcoes }));
    });
    return guias;
  }  
  async getGuiasLote (codLote) {
    let guias = [];
    let brancoAcoes = '';
    const urlGuiasLoteRecursoGeral = resolve('urlGuiasLoteRecursoGeral') + codLote
    const { data } = await this.fetch(urlGuiasLoteRecursoGeral);
    data.map(res => {
      const { codGuia, numGuiaPrestador, numGuiaOperadora, numCarteiraTst, nomeBeneficiario, valTotalGlosado, valTotalLiberado, valTotalProcessado, codVersaoTiss, txtNumeroFatura } = res;
      guias.push(Object.values({ codGuia, numGuiaPrestador, numGuiaOperadora, numCarteiraTst, nomeBeneficiario, valTotalProcessado, valTotalLiberado, valTotalGlosado, codVersaoTiss, txtNumeroFatura, brancoAcoes }));
    });
    return guias;
  }    
  async excluirGuiaRecurso (codLote, codGuia){
    const urlExcluirGuiaRecurso = resolve('urlExcluirGuiaRecurso') + codLote + '/guia/' + codGuia + '/excluir';
    const result = await this.fetch(urlExcluirGuiaRecurso, 'PUT');
    return result;
  }
  async anexarArquivo (codLoteGuia, codGuia, nomeArquivo, txtObjetoGed) {
    try {
      const urlAnexarArquivoGuia = resolve('urlAnexarArquivoGuia') + codLoteGuia + '/guia/' + codGuia + '/anexar_arquivo/' + nomeArquivo + '/' + txtObjetoGed;
      const response = await this.fetch(urlAnexarArquivoGuia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (codLoteGuia, codGuia) {
    try {
      const consultarArquivosGuiaUrl = resolve('consultarArquivosGuiaUrl') + codLoteGuia + '/guia/' + codGuia + '/arquivos';
      const response = await this.fetch(consultarArquivosGuiaUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codLoteGuia, codGuia, codArquivo) {
    try {
      const urlDeletarArquivoGuia = resolve('urlDeletarArquivoGuia') + codLoteGuia + '/guia/' + codGuia + '/deletar_arquivo/' + codArquivo;
      const response = await this.fetch(urlDeletarArquivoGuia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }}

export default GuiaApi;
